import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

const PIN_LENGTH = 6;

interface PinDotsProps {
  length: number;
  error?: boolean;
  /**
   * 'light' (padrão): borda escura sobre fundo claro. 'dark': borda branca
   * translúcida — usado sobre a foto de fundo do login (src/pages/PinLogin.tsx).
   */
  variant?: 'light' | 'dark';
}

/**
 * 6 círculos que preenchem conforme o PIN é digitado, estilo banco.
 * "Balança" (shake) quando `error` é true, sinalizando PIN incorreto.
 */
export function PinDots({ length, error, variant = 'light' }: PinDotsProps) {
  return (
    <motion.div
      className="flex justify-center gap-4"
      animate={error ? { x: [0, -8, 8, -8, 8, 0] } : { x: 0 }}
      transition={{ duration: 0.4 }}
      role="status"
      aria-label={`${length} de ${PIN_LENGTH} dígitos preenchidos`}
    >
      {Array.from({ length: PIN_LENGTH }).map((_, index) => (
        <div
          key={index}
          className={cn(
            'h-4 w-4 rounded-full border-2 transition-colors',
            index < length
              ? 'bg-primary border-primary'
              : variant === 'dark' ? 'border-white/30' : 'border-muted-foreground/40',
            error && 'border-destructive',
            error && index < length && 'bg-destructive',
          )}
        />
      ))}
    </motion.div>
  );
}
